import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ca1df08"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "SupplyDetail"
}
const _hoisted_2 = { class: "titleWarpper" }
const _hoisted_3 = {
  class: "titlecontainer",
  style: {"flex":"1"}
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "report" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "举报", -1))
const _hoisted_7 = { class: "priceWarpper" }
const _hoisted_8 = { class: "price" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "￥", -1))
const _hoisted_10 = { class: "views" }
const _hoisted_11 = { class: "user" }
const _hoisted_12 = { class: "userInfo" }
const _hoisted_13 = { class: "info" }
const _hoisted_14 = { class: "name" }
const _hoisted_15 = { class: "time" }
const _hoisted_16 = { class: "userLocation" }
const _hoisted_17 = { class: "supply" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("进入苗圃")
const _hoisted_19 = { class: "address" }
const _hoisted_20 = { class: "addressName" }
const _hoisted_21 = { class: "detail" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "详细内容", -1))
const _hoisted_23 = { class: "detailWarpper" }
const _hoisted_24 = { class: "label" }
const _hoisted_25 = { class: "value" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "* 联系我时，请说是在苗搭档看到的，谢谢！", -1))
const _hoisted_27 = { class: "images" }
const _hoisted_28 = { class: "actions" }
const _hoisted_29 = { class: "collection" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "收藏", -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode("电话联系")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "呼叫电话", -1))
const _hoisted_33 = { class: "telNum" }
const _hoisted_34 = { class: "btn" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("暂不拨打")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("立即呼叫")
const _hoisted_37 = { class: "notFollow" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "苗搭档", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, "找苗、卖苗快人一步 为了匹配更好的求购处理 请关注公众号", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "长安二维码识别关注", -1))
const _hoisted_41 = { class: "notFollow" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title1" }, "温馨提示", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content1" }, "尊敬的用户，查看信息、免费报价、查看电话等都需要实名认证，请尽快进行身份信息认证！", -1))
const _hoisted_44 = { class: "btn1" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("暂不实名")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("我要实名")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoPlayer = _resolveComponent("VideoPlayer")!
  const _component_VanSwipeItem = _resolveComponent("VanSwipeItem")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanSwipe = _resolveComponent("VanSwipe")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanIcon = _resolveComponent("VanIcon")!
  const _component_vanButton = _resolveComponent("vanButton")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (Object.keys($setup.detail).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_VanSwipe, { class: "swiper" }, {
          default: _withCtx(() => [
            ($setup.detail.video.length)
              ? (_openBlock(), _createBlock(_component_VanSwipeItem, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VideoPlayer, {
                      class: "video",
                      src: $setup.detail.video[0].value,
                      autoplay: "",
                      loop: "",
                      language: "zh"
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.detail.photos, (img) => {
              return (_openBlock(), _createBlock(_component_VanSwipeItem, {
                key: img.key
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VanImage, {
                    src: img.value,
                    alt: "图片",
                    width: "100%",
                    height: "100%"
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString($setup.detail.title), 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_VanButton, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push({name:"Report",query:{id:$setup.route.query.id}}))),
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VanImage, {
                    src: require('@/assets/img/jubao.png'),
                    alt: "图片",
                    width: "1rem",
                    height: "1rem"
                  }, null, 8, ["src"]),
                  _hoisted_6
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createTextVNode(_toDisplayString($setup.detail.price||'电议'), 1),
              _createElementVNode("span", null, "/" + _toDisplayString($setup.detail.unit), 1)
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString($setup.detail.supplyFlows) + "人浏览", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_VanImage, {
              src: $setup.detail.information.avatarUrl,
              alt: "图片",
              width: "40",
              height: "40",
              round: ""
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString($setup.detail.information.nickName), 1),
              _createElementVNode("div", _hoisted_15, "已持续运营" + _toDisplayString($setup.detail.information.operating) + "天", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, "供应" + _toDisplayString($setup.detail.information.supplies) + "条", 1),
            _createVNode(_component_VanButton, {
              color: "#fec64b",
              size: "mini",
              round: "",
              onClick: $setup.jumpApplet
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_VanIcon, { name: "location" }),
            _createElementVNode("div", _hoisted_20, _toDisplayString($setup.detail.address), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.detail.specifications, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "detailItem",
                key: item.id
              }, [
                _createElementVNode("div", _hoisted_24, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_25, _toDisplayString(typeof item.value == 'object'?item.value.join('~'):item.value) + " " + _toDisplayString(item.unit), 1)
              ]))
            }), 128))
          ]),
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.detail.photos, (img) => {
              return (_openBlock(), _createBlock(_component_VanImage, {
                src: img.value,
                alt: "图片",
                width: "100%",
                height: "100%",
                key: img.key
              }, null, 8, ["src"]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_VanIcon, {
              name: "like-o",
              size: "28"
            }),
            _hoisted_30
          ]),
          _createVNode(_component_VanButton, {
            color: "#fec64b",
            round: "",
            block: "",
            onClick: $setup.getTel
          }, {
            default: _withCtx(() => [
              _hoisted_31
            ]),
            _: 1
          })
        ]),
        _createVNode($setup["RestrictDialog"], {
          modelValue: $setup.restrictShow,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.restrictShow) = $event)),
          code: $setup.restrictCode,
          type: "supply"
        }, null, 8, ["modelValue", "code"]),
        _createVNode(_component_VanPopup, {
          class: "callDialog",
          show: $setup.isShowTel,
          "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (($setup.isShowTel) = $event))
        }, {
          default: _withCtx(() => [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createTextVNode("是否拨打 " + _toDisplayString($setup.tel), 1),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_vanButton, {
                  round: "",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.cancel())),
                  icon: "close",
                  size: "mini"
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                }),
                _createVNode(_component_vanButton, {
                  round: "",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.call())),
                  icon: "phone",
                  color: "#33AC9C",
                  size: "mini"
                }, {
                  default: _withCtx(() => [
                    _hoisted_36
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_VanPopup, {
          show: $setup.isNotFollow,
          "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (($setup.isNotFollow) = $event)),
          style: {"width":"80vw","border-radius":"4px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _hoisted_39,
              _createVNode(_component_VanImage, {
                src: "https://mdd-static.oss-cn-hangzhou.aliyuncs.com/wechat/gzh.jpg",
                style: {"width":"100%"},
                radius: "4"
              }),
              _hoisted_40
            ])
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_VanPopup, {
          show: $setup.isRealName,
          "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => (($setup.isRealName) = $event)),
          style: {"width":"80vw","border-radius":"4px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_vanButton, {
                  round: "",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.cancelRealName())),
                  size: "mini"
                }, {
                  default: _withCtx(() => [
                    _hoisted_45
                  ]),
                  _: 1
                }),
                _createVNode(_component_vanButton, {
                  round: "",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.gotoRealName())),
                  style: {"border":"solid 1px #f00","margin-left":"20px"},
                  type: "danger",
                  size: "mini"
                }, {
                  default: _withCtx(() => [
                    _hoisted_46
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ]))
    : _createCommentVNode("", true)
}